export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client) {
    // setTimeout(() => {
    //   window?.scrollTo({ top: 0, left: 1, behavior: 'smooth' });
    // }, 400);
  }
});
